import React, { useState, useEffect, useRef } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';

//Components
import Fluxogram from '../../../../../components/Fluxograma';
import ModalCustomized from '../../../../../components/Modal/Modal';
import TextField from '../../../../../components/TextField';

//Helpers
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage, showQuestion } from '../../../../../helpers/message';

//Api
import modelosEmail_api from '../../../../../api/modelosEmail_api';
import tipoRequerimento_api from '../../../../../api/tipoRequerimento_api';
import formulario_api from '../../../../../api/formulario_api';

//Context
import { useAuth } from '../../../../../context/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

function initialStateAcao(hashPai, idPai) {
    return {
        identificacao: "",
        excluido: "false",
        gerarBoleto: "false",
        modeloEmail_Id: null,
        hashEtapa: hashPai,
        tipoRequerimentoEtapa_Id: idPai,
        formulario_Id: null,
        requerAgendamento: "false",
        cor: "success",
        informarTipoCompensacao: "false",
        informarNumeroProcesso: "false",
        default: "false",
        tipoRequerimentoEtapaProximaAcaos: []
    }
}
export default function Workflow({ tipoRequerimento, setTipoRequerimento, editavel }) {
    const { setLoading } = useAuth();

    //Estado que guarda as opções de modelos de emails
    const [modelosEmail, setModelosEmail] = useState([]);

    //Estado que guarda os valores da ação a ser adicionada
    const [acao, setAcao] = useState(initialStateAcao);

    //Estado de controle das açoes que serão exibidas no fluxograma
    const [acoes, setAcoes] = useState([]);

    //Estado de controle dos erros nos campos de adicionar ação
    const [errors, setErrors] = useState({});

    //Estado de controle das opções de formularios
    const [formularios, setFormularios] = useState([]);

    //Campos obrigatorios para adicionar uma ação
    const campos = [objCampo({ name: "identificacao", required: true })];

    //Estado de controle de visibilidade do modal que adiciona a nova ação
    const [visibleModal, setVisibleModal] = useState(false);

    const ref = useRef(null);


    const handlePrint = () => {
        html2canvas(ref.current).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save(`Fluxo ${tipoRequerimento.identificacao}`);
        });
    };

    //Função de controle de visibilidade do modal
    const toggleModal = (hashPai) => {
        setVisibleModal(!visibleModal)
        if (!visibleModal)
            setAcao(initialStateAcao(hashPai, tipoRequerimento.tipoRequerimentoEtapas.filter(value => value.hash == hashPai)[0].id));
    };

    //Função de editar uma ação
    const editarAcao = (hash, hashPai) => {
        const _acao = tipoRequerimento.tipoRequerimentoEtapasAcoes.filter(value => value.hashEtapa == hashPai && value.tipoRequerimentoEtapaProximaAcaos[0].hashEtapa == hash);
        if (_acao.length > 0) {
            loadAcao(_acao[0].id);
        }
    }

    //Função de remover uma ação
    const removerAcao = () => {
        const maiorIdFluxo = tipoRequerimento.tipoRequerimentoEtapasAcoes.sort((a, b) => b.id - a.id)[0].id;

        if (acao.id != maiorIdFluxo) {
            showMessage("Aviso", "Você so pode remover uma ação na ordem contraria em que elas foram adicionadas!", "info", null);
            return;
        }

        showQuestion("Tem certeza?", "tem certeza de que deseja deletar essa ação?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    setLoading(true);
                    tipoRequerimento_api.deleteTipoRequerimentoEtapaAcao(acao.id).then(response => {
                        showMessage("Sucesso", "Ação removida com sucesso!", "success", () => {
                            toggleModal();
                            loadAcoes();
                        });
                    }).catch(e => showMessage("Erro", e.message, "error", null))
                        .finally(f => setLoading(false));
                }
            })

    }
    //Função de onChange dos campos do modal
    const onChange = (e) => {
        const { name, value } = e.target;
        setAcao({
            ...acao,
            [name]: value
        });
    }

    //Função de onchange para o campo de etapa
    const onChangeEtapa = (value, e) => {

        setAcao({
            ...acao,
            tipoRequerimentoEtapaProximaAcaos: value
                ? [
                    {
                        ...acao.id ? { tipoRequerimentoEtapaAcao_Id: acao.id } : {},
                        hashEtapa: value.value,
                        tipoRequerimentoEtapa_Id: tipoRequerimento.tipoRequerimentoEtapas.filter(etapa => etapa.hash == value.value)[0].id
                    }
                ]
                : []
        });
    }
    //onChange para o campo de modelo de email
    const onChangeModeloEmail = (value, e) => {
        setAcao({
            ...acao,
            [e.name]: value ? value.value : null,
        });

    }

    //Carrega os modelos de emails para cadastro de etapas
    const loadModelosEmail = () => {
        setLoading(true);
        modelosEmail_api.getList().then(response => {
            setModelosEmail(response.data.map(value => {
                value.id = value.id.toString();
                return value;
            }));
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    //Carrega os formularios para o cadastro das ações
    const loadFormularios = () => {
        setLoading(true);
        formulario_api.getList({ status: "Ativo", finalidade: "Processo" }).then(response => {
            setFormularios(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Funçao que carrega as ações do tipo de requerimento
    const loadAcoes = () => {
        setLoading(true);
        tipoRequerimento_api.GetTipoRequerimentoEtapasAcoes(tipoRequerimento.id).then(response => {
            const _tipoRequerimento = { ...tipoRequerimento };
            _tipoRequerimento.tipoRequerimentoEtapasAcoes = response.data;
            setTipoRequerimento(_tipoRequerimento);
            organizarAcoes(response.data);
            loadModelosEmail();
            loadFormularios();
        }).catch(ex => showMessage("Aviso!", ex.message, 'error', null))
            .finally(f => setLoading(false));
    }

    //Estado que carrega os dados da ação selecionado
    const loadAcao = (id) => {
        setLoading(true);
        tipoRequerimento_api.GetTipoRequerimentEtapaAcao(id).then(response => {
            response.data.excluido = response.data.excluido.toString();
            response.data.gerarBoleto = response.data.gerarBoleto.toString();
            response.data.requerAgendamento = response.data.requerAgendamento.toString();
            response.data.informarTipoCompensacao = (response.data.informarTipoCompensacao == true).toString();
            response.data.informarNumeroProcesso = (response.data.informarNumeroProcesso == true).toString();
            response.data.default = (response.data.default == true).toString();
            if (response.data.modeloEmail_Id)
                response.data.modeloEmail_Id = response.data.modeloEmail_Id.toString();

            setAcao(response.data);
            setVisibleModal(true);
        }).catch(ex => showMessage("Aviso!", ex.message, 'error', null))
            .finally(f => setLoading(false));
    }
    //Função que inicializa o vetor das ações do fluxograma
    const organizarAcoes = (novasAcoes) => {
        const _acoes = [...novasAcoes ? novasAcoes : tipoRequerimento.tipoRequerimentoEtapasAcoes];
        if (_acoes.length == 0) {
            setAcoes(tipoRequerimento.tipoRequerimentoEtapas.filter(value => {
                return value.inicial == "true"
            }).map(value => {
                return { name: value.identificacao, hash: value.hash, etapaInicial: true }
            }));
            return;
        }
        setAcoes([
            ...tipoRequerimento.tipoRequerimentoEtapas.filter(value => {
                return value.inicial == "true"
            }).map(value => {
                return { name: value.identificacao, hash: value.hash, etapaInicial: true }
            }),
            ..._acoes.map(acao => {
                const etapaSelecionada = tipoRequerimento.tipoRequerimentoEtapas.filter(etapa => etapa.hash == acao.tipoRequerimentoEtapaProximaAcaos[0].hashEtapa)[0];
                return { name: etapaSelecionada.identificacao, hash: acao.tipoRequerimentoEtapaProximaAcaos[0].hashEtapa, hashPai: acao.hashEtapa, textoConector: acao.identificacao, etapaFinal: etapaSelecionada.final == "true" }
            })
        ]
        )

    }

    //onChange para o formulario
    const onChangeFormulario = (value, e) => {
        setAcao({
            ...acao,
            [e.name]: value ? value.value : null,
        });

    }
    //Função que adiciona a ação informada
    const onSubmit = () => {
        const _errors = validarCampos(acao, campos);
        if (!acao.tipoRequerimentoEtapaProximaAcaos[0] || !acao.tipoRequerimentoEtapaProximaAcaos[0].hashEtapa) {
            _errors[0].etapa = { message: "" };
            _errors[1].push({ name: "etapa", required: true });
        }

        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        let _acao = { ...acao };

        setLoading(true);
        if (_acao.id) {
            delete _acao.tipoRequerimentoEtapaProximaAcaos;
            delete _acao.tipoRequerimentoEtapa;
            tipoRequerimento_api.putTipoRequerimentoEtapaAcao(_acao).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar a ação!", 'success', () => {
                    toggleModal(null);
                    loadAcoes();
                });
            }).catch(ex => {
                showMessage("Erro", ex.message, 'error', null);
            }).finally(f => setLoading(false));
        } else {
            tipoRequerimento_api.postTipoRequerimentoEtapaAcao(_acao).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar a ação!", 'success', () => {
                    toggleModal(null);
                    loadAcoes();
                });
            }).catch(ex => {
                showMessage("Erro", ex.message, 'error', null);
            }).finally(f => setLoading(false));
        }
    }

    useEffect(() => {
        if (!tipoRequerimento.tipoRequerimentoEtapasAcoes) {
            loadAcoes();
        } else {
            organizarAcoes();
            loadModelosEmail();
            loadFormularios();
        }
    }, []);
    return (
        <>
            <div className='d-flex align-items-center justify-content-between'>
                <h5 className='mb-3'>Workflow</h5>
                {/* <Button color='danger' onClick={handlePrint}><FontAwesomeIcon icon={faFilePdf} /> Imprimir</Button> */}
            </div>
            <ModalCustomized title={acao.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Cadastrar"} isOpen={visibleModal} toggle={toggleModal} btnClose={true}>
                <Row>
                    <Col md="6" lg={acao.tipoRequerimentoEtapaProximaAcaos.length > 0 && tipoRequerimento.tipoRequerimentoEtapas.filter(value => value.hash == acao.tipoRequerimentoEtapaProximaAcaos[0].hashEtapa)[0].responsavel != "Fiscal" ? "6" : "12"}>
                        <TextField
                            label={"* Identificação"}
                            name={"identificacao"}
                            value={acao.identificacao}
                            onChange={onChange}
                            invalid={errors.identificacao}
                            maxLength={70}
                            disabled={!editavel}
                        />
                    </Col>
                    {
                        acao.tipoRequerimentoEtapaProximaAcaos.length > 0
                        && tipoRequerimento.tipoRequerimentoEtapas.filter(value => value.hash == acao.tipoRequerimentoEtapaProximaAcaos[0].hashEtapa)[0].responsavel != "Fiscal" &&
                        <Col md="6" lg="6">
                            <TextField
                                label={"Formulário"}
                                name={"formulario_Id"}
                                type={"select"}
                                options={formularios.map(value => { return { value: value.id, label: value.identificacao } })}
                                searchable
                                onChange={onChangeFormulario}
                                value={formularios.filter(formulario => formulario.id === acao.formulario_Id).map(value => { return { value: value.id, label: value.identificacao } })}
                                invalid={!!errors.formulario_Id}
                                disabled={!editavel}
                            />
                        </Col>
                    }
                    <Col md="12" lg="12">
                        <TextField
                            label={"* Etapa"}
                            name={"etapa"}
                            type={"select"}
                            searchable
                            value={acao.tipoRequerimentoEtapaProximaAcaos.length > 0
                                ? tipoRequerimento.tipoRequerimentoEtapas.filter(value => value.hash == acao.tipoRequerimentoEtapaProximaAcaos[0].hashEtapa).map(value => {
                                    return { value: value.hash, label: value.identificacao };
                                })[0]
                                : null}
                            onChange={onChangeEtapa}
                            options={tipoRequerimento.tipoRequerimentoEtapas.map(value => {
                                return { value: value.hash, label: value.identificacao }
                            })}
                            invalid={errors.etapa}
                            disabled={!!acao.id || !editavel}
                        />
                    </Col>
                    <Col md="12" lg="8">
                        <TextField
                            label={"Modelo de e-mail"}
                            name={"modeloEmail_Id"}
                            onChange={onChangeModeloEmail}
                            type={"select"}
                            searchable
                            options={modelosEmail.map(value => { return { value: value.id, label: value.identificacao } })}
                            value={
                                acao.modeloEmail_Id ?
                                    modelosEmail.filter(documento => acao.modeloEmail_Id === documento.id)
                                        .map(value => { return { value: value.id, label: value.identificacao } })[0]
                                    : null
                            }
                            invalid={!!errors.modeloEmail_Id}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            label={"Cor"}
                            name={"cor"}
                            onChange={onChange}
                            type={"select"}
                            options={[
                                { label: "Verde", value: "success" },
                                { label: "Azul", value: "primary" },
                                { label: "Amarelo", value: "warning" },
                                { label: "Vermelho", value: "danger" },
                            ]}
                            value={
                                acao.cor
                            }
                            invalid={!!errors.cor}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="6" lg="6">
                        <TextField
                            type={"radio"}
                            label="* Gera boleto?"
                            name={"gerarBoleto"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.gerarBoleto}
                            invalid={!!errors.gerarBoleto}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="6" lg="6">
                        <TextField
                            type={"radio"}
                            label="* Requer agendamento?"
                            name={"requerAgendamento"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.requerAgendamento}
                            invalid={!!errors.requerAgendamento}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Informar tipo de compensação"
                            name={"informarTipoCompensacao"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.informarTipoCompensacao}
                            invalid={!!errors.informarTipoCompensacao}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Informar número de processo"
                            name={"informarNumeroProcesso"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.informarNumeroProcesso}
                            invalid={!!errors.informarNumeroProcesso}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"radio"}
                            label="* Ação padrão"
                            name={"default"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={acao.default}
                            invalid={!!errors.default}
                            disabled={!editavel}
                        />
                    </Col>
                    {editavel &&
                        <Col className='d-flex align-items-center justify-content-center my-3' md="12" lg="12">
                            <Button color={acao.id ? "warning text-white" : 'success'} className='px-5' onClick={onSubmit}>
                                {acao.id
                                    ?
                                    <><FontAwesomeIcon icon={faEdit} /> Editar</>
                                    :
                                    "+ Cadastrar"
                                }
                            </Button>
                            {acao.id && tipoRequerimento.tipoRequerimentoEtapasAcoes.sort((a, b) => b.id - a.id)[0].id == acao.id &&
                                <Button color='danger' onClick={removerAcao} className='px-5 ms-3'>
                                    <FontAwesomeIcon icon={faTrash} /> Remover
                                </Button>
                            }
                        </Col>
                    }

                </Row>
            </ModalCustomized>
            {acoes.length > 0 &&
                <Fluxogram containerRef={ref} nodes={acoes} onClickAdicionar={editavel ? toggleModal : null} onClickConector={editarAcao} />
            }
        </>
    )
}